import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { ProjectsAndDomainsComponent } from './projects-and-domains/projects-and-domains.component';
import { DashboardComponent } from './dashboard.component';
import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbProgressbar, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MonTableSortModule } from '@monsido/angular-shared-components';
import { SharedModule } from '@client/ng2/shared/shared.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import {
    DomainActionMenuButtonComponent,
} from '@client/app/pages/dashboard/domain-action-menu-button/domain-action-menu-button.component';
import {
    DomainGroupActionMenuButtonComponent,
} from '@client/app/pages/dashboard/domain-group-action-menu-button/domain-group-action-menu-button.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        NgbTooltip,
        FormsModule,
        MonTableSortModule,
        NgbProgressbar,
        SharedModule,
        ExtensionModule,
        DomainActionMenuButtonComponent,
        DomainGroupActionMenuButtonComponent,
    ],
    declarations: [
        ProjectsAndDomainsComponent,
        DashboardComponent,
    ],
    exports: [
        ProjectsAndDomainsComponent,
        DashboardComponent,
    ],
})
export class UpgradeDashboardModule {}
